export enum AreaAtuacaoStatusEnum {
    HABILITADA = 'HABILITADA',
    DESABILITADA = 'DESABILITADA'
}
